<template>
  <v-container class="mt-8">
    <v-card variant="flat" class="pa-2">
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card class="mb-4" flat outlined>
            <v-card-title class="subtitle-1 font-weight-bold"
              >Dados do Município</v-card-title
            >
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model.number="municipio.codmunicipioibge"
                    label="Código IBGE"
                    :rules="[rules.required, rules.isNumber]"
                    prepend-inner-icon="mdi-numeric"
                    required
                    clearable
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model.number="municipio.latitude"
                    label="Latitude"
                    prepend-inner-icon="mdi-map-marker"
                    clearable
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model.number="municipio.longitude"
                    label="Longitude"
                    prepend-inner-icon="mdi-map-marker"
                    clearable
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="10">
                  <v-text-field
                    v-model="municipio.nome_municipio"
                    label="Nome do Município"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-city"
                    required
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model="municipio.sigla_uf"
                    label="Sigla UF"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-map-outline"
                    required
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model.number="municipio.cod_uf"
                    label="Código UF"
                    prepend-inner-icon="mdi-map"
                    clearable
                    type="number"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider class="my-2"></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn
          size="large"
          block
          variant="elevated"
          color="primary"
          @click="salvarMunicipio"
          :loading="loading"
        >
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import rulesMixin from "@/mixins/rulesMixin";
import api from "../services/api";
import { mapActions } from "vuex";

export default {
  mixins: [rulesMixin],
  data: () => ({
    valid: false,
    loading: false,
    municipio: {
      codmunicipioibge: null,
      nome_municipio: "",
      latitude: null,
      longitude: null,
      cod_uf: null,
      sigla_uf: "",
    },
  }),
  methods: {
    ...mapActions(["triggerFeedback"]),
    async salvarMunicipio() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      try {
        await api.post("/municipios/", this.municipio);
        this.triggerFeedback({
          message: "Município cadastrado com sucesso!",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.$router.push({ name: "municipios" });
      } catch (error) {
        console.error("Erro ao cadastrar município:", error);
        this.triggerFeedback({
          message: "Erro ao cadastrar município!",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.v-card-title {
  align-items: center;
  justify-content: center;
}
.v-card-actions {
  justify-content: flex-end;
}
</style>
